export default "__VITE_ASSET__2tyiZmw___"